import api from '../../lib/api';
import { url_api_v1_wardrobe_kit_get, url_api_v1_wardrobe_kit_doc_add, url_api_v1_wardrobe_kit_doc_remove, url_api_v1_wardrobe_kit_doc_markfeatured } from '../../lib/apiUrl';
import { WardrobeKitDocumentModel } from '../submission_kits/components/KitModels';

class WardrobeKitService {
  getWardrobeKitDocuments = async () => {
    try {
      const url = url_api_v1_wardrobe_kit_get;
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in getting wardrobe kit documents.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  addInWardrobeKitDocument = async (kit_id: any, tag: string) => {
    try {
      const url = url_api_v1_wardrobe_kit_doc_add;
      const response = await api.post(url, {
        kit_document_id: kit_id,
        tag: tag,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in adding media in wardrobe kit.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  
  deleteFromWardrobeKitDocument = async (wardrobeKitDocument: WardrobeKitDocumentModel) => {
    try {
      const url = url_api_v1_wardrobe_kit_doc_remove;
      const response = await api.post(url, {
        id: wardrobeKitDocument.id,
        wardrobe_kit_id: wardrobeKitDocument.wardrobe_kit_id,
        kit_document_id: wardrobeKitDocument.kit_document_id,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error removing media from wardrobe kit.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
  markKitAsFeatured = async (wardrobe_kit_id: number, kit_document_id: number, featured:boolean) => {
    try {
      const url = url_api_v1_wardrobe_kit_doc_markfeatured;
      const response = await api.put(url, {
        wardrobe_kit_id: wardrobe_kit_id,
        kit_document_id: kit_document_id,
          featured: featured?'1':'0',
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error removing media from wardrobe kit.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
  
}

const wardrobeKitService = new WardrobeKitService();

export default wardrobeKitService;

